import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IWithdrawTransactions {
    action?: string
    action_parent_id?: string
    amount?: number
    balance_after?: number
    coin?: string
    created_at?: string
    extra?: string
    id?: string
    user_id?: string
    wallet_id?: string
}

export const getWithdrawTransactions = async (id?: string): Promise<ApiRes<IWithdrawTransactions[]>> => {
    if (!id) return
    return await apiGet(API_URL, `admin/payment/transactions?user_id=${id}&limit=0&skip=0&action=`)
}
